import "bootstrap/dist/css/bootstrap.min.css";
import NavbarComponent from "./Navbar";
import "../bootstrap_overrides.css";
import github from "../github.png";
import SplitContentView from "./SplitContentView";

function App() {
  return (
    <>
      <NavbarComponent />
      <SplitContentView />
      <div className="footer">
        <p>
          Made by &nbsp;{" "}
          <a
            href="https://github.com/vigneshiyergithub"
            target="_blank"
            rel="noreferrer"
          >
            <img src={github} alt="github" className="githubIcon" />
          </a>
          {" "}You can {" "}
          <a
            href="https://www.buymeacoffee.com/vigneshiyer94"
            target="_blank"
            rel="noreferrer"
          >
            buy me coffee
          </a>{" "}
          if you like my work.
        </p>
      </div>
    </>
  );
}

export default App;
